import './types';

/**
 * @param {StatsLeadersState} draft - Draft state.
 * @param {StatsLeadersSortState} payload - Action payload.
 */
export const setDataType = ( draft, payload ) => {
    draft.dataType = {
        ...draft.dataType,
        ...payload
    };
};